import {Component, Inject, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import {MainContainer} from "~/components/main-container";
import {PageTitle} from "~/components/page-title";
import {icons} from "~/components/icon";
import {AppSettings} from "~/lib/app-settings";
import {Tab, Tabs} from "~/components/tabs";
import {NotificationsEditor} from "~/modules/notifications/components/notifications-editor";
import {NotificationsList} from "~/modules/notifications/components/notifications-list";
import {NotificationModal} from "~/modules/notifications/components/notification-preview";

@Component
export class NotificationsView extends Vue {

  @Getter currentUser;
  @Inject() appSettings: AppSettings;

  protected currentTab: "publication" | "list" = "publication";
  protected preview: Notification = null;

  setPreview(notification:Notification){
    this.preview = notification;
  }

  renderContent(){
    switch(this.currentTab){
      case "publication": return <NotificationsEditor onPreviewNotification={this.setPreview} /> ;
      case "list": return <NotificationsList onPreviewNotification={this.setPreview}/>;
    }
  }

  render() {
    return (
      <MainContainer>
        <PageTitle icon={icons.notification} title="Notifications"/>

        <Tabs>
          <Tab isActive={this.currentTab === "publication"} onClick={() => this.currentTab = "publication"}>
            Publication
          </Tab>
          <Tab isActive={this.currentTab === "list"} onClick={() => this.currentTab = "list"}>
            Notifications publiées
          </Tab>
        </Tabs>

        <div class="page-content">
          {this.renderContent()}
        </div>

        {this.preview && <NotificationModal
            notification={this.preview}
            onClose={() => this.preview = null}
        />}

      </MainContainer>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-61c18c3c/notifications-view.tsx" });